import React from 'react'
import styled from 'styled-components'
import { dataAttr } from '@mote/helpers'
import { Block, Button } from '@mote/ui'
import { useAdminSchools } from './adminSchools.context'

export const AdminSchoolsPaginator = () => {
  const {
    refreshSchoolsPaginated,
    state: { pageIndex, pageIndexes, loading }
  } = useAdminSchools()
  const [activePage, setActivePage] = React.useState(pageIndex)

  const getPageLink = React.useCallback(
    (index, label) => {
      if (!label) {
        label = index + 1
      }

      return (
        <PageButton
          variant='soft'
          onClick={() => {
            setActivePage(index)
            refreshSchoolsPaginated(index)
          }}
          text={label}
        />
      )
    },
    [refreshSchoolsPaginated]
  )

  React.useEffect(() => {
    setActivePage(pageIndex)
  }, [pageIndex])

  if (pageIndexes.length < 2) {
    return null
  }

  return (
    <Block
      layout='horizontal'
      justify='center'
      gap={12}
      wrapped
      spreadX
      style={{
        pointerEvents: loading ? 'none' : 'auto',
        opacity: loading ? 0.5 : 1
      }}
    >
      {pageIndexes.map((page, id) => {
        const [pageNumber, label] = Array.isArray(page) ? page : [page, page]
        const isCurrentOrEllipsis = pageNumber === '...'
        const isActivePage = pageNumber - 1 === activePage

        return (
          <React.Fragment key={`${pageNumber}-${label}-${id}`}>
            {isActivePage && (
              <NonPageNumber data-active={dataAttr(isActivePage)}>
                {label}
              </NonPageNumber>
            )}
            {isCurrentOrEllipsis && <NonPageNumber>{pageNumber}</NonPageNumber>}
            {!(isCurrentOrEllipsis || isActivePage) &&
              getPageLink(pageNumber - 1, label)}
          </React.Fragment>
        )
      })}
    </Block>
  )
}

const PageButton = styled(Button)`
  padding: 0;
  width: 40px;
`

const NonPageNumber = styled.span`
  display: inline-flex;
  font-style: normal;
  font-weight: 400;
  color: #ffffff;
  line-height: 120%;
  text-align: center;
  font-size: 15px;
  color: #232323;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  cursor: default;
  user-select: none;
  touch-action: manipulation;
  outline-offset: 2px;
  border-radius: 4px;
  border: none;
  height: 40px;
  width: 40px;
  text-decoration: none;
  box-sizing: border-box;
  white-space: nowrap;
  vertical-align: middle;
  background: transparent;
  outline: transparent solid 2px !important;

  &[data-active] {
    color: #ffffff;
    background: #ac0ae8;
  }
`
